import type { ChangeEvent } from "react";
import {
  Button,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import shallow from "zustand/shallow";

import { useStoreSystem } from "../../../../store";
import { useAlerts } from "../../../../hooks/useAlerts";
import { useViewFullscreen } from "../../../../hooks/useViewFullscreen";

const FullscreenIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M2.25 6.25V2.25H6.25"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 2.25H16.75V6.25"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.75 12.75V16.75H12.75"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 16.75H2.25V12.75"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ViewPanel = () => {
  const { isWallsGreen, setSystemProperties } = useStoreSystem(
    (state) => ({
      isWallsGreen: state.isWallsGreen,
      setSystemProperties: state.setSystemProperties,
    }),
    shallow
  );

  const { enterFullscreen } = useViewFullscreen();
  const { addReadyAlert } = useAlerts();

  const onToggleWallsColor = (event: ChangeEvent<HTMLInputElement>) => {
    setSystemProperties([
      {
        name: "isWallsGreen",
        value: event.target.checked,
      },
    ]);
  };

  const onFullscreenClick = async () => {
    try {
      await enterFullscreen();
    } catch (error) {
      console.error(error);
      addReadyAlert(
        "Не удалось открыть полноэкранный режим",
        "error"
      );
    }
  };

  return (
    <Stack spacing={1.75} alignItems="flex-start">
      <Typography fontSize={18}>
        Посмотрите, как выглядит Ваш проект
      </Typography>

      <Stack
        direction="row"
        alignItems="center"
        spacing={3}
      >
        <Button
          variant="outlined"
          startIcon={<FullscreenIcon />}
          onClick={onFullscreenClick}
          sx={{
            px: 2,
            py: 0.875,
            minHeight: 40,
            borderRadius: "10px",
            textTransform: "none",
            whiteSpace: "nowrap",
            boxShadow: "none",
          }}
        >
          На весь экран
        </Button>
        <FormControlLabel
          labelPlacement="start"
          sx={{
            m: 0,
            gap: 1,
            userSelect: "none",

            "& .MuiFormControlLabel-label": {
              lineHeight: 1,
            },
          }}
          label={
            <Typography
              fontSize={14}
              lineHeight={1.4}
              color="#838280"
              whiteSpace="nowrap"
            >
              Ярко-зелёные стены
            </Typography>
          }
          control={
            <Switch
              checked={isWallsGreen}
              onChange={onToggleWallsColor}
              inputProps={{
                "aria-label":
                  "Переключить ярко-зелёный цвет стен",
              }}
            />
          }
        />
      </Stack>
    </Stack>
  );
};
